export const colors = {
  default: "#45969B",
  background: "#F7F1F1",
  orange: "#FDA52B",
  pink: "#FF6EC0",
  blue: "#0CB4FF",
  emerald: "#2FD295",
  turquoise: "#50B6BB",
  darkDefault: "#16697B", 
  darkOrange: "#DB6400",
  disabled: "#E5E5E5",
  public: "#23a9f7",
  municipal: "#12c45c",
  private: "#FF0045",
  hybrid: "#FF6200",
}

export const translateColorByRedeId = (redeId) => {
  switch (redeId) {
    case "1":
      return colors.orange;
    case "2":
      return colors.turquoise;
    case "3":
      return colors.emerald;
    case "4":
      return colors.pink;
    case "5":
      return colors.blue;
    default:
      return colors.default;
  }
}